import React, { FC } from 'react'
import { LoginCallback } from '@okta/okta-react'
import { Link as RouteLink } from 'react-router-dom'
import { routes } from 'config'
import {
  BaseLayout,
  Module,
  ModuleHeader,
  CustomAlert,
  ButtonContainer,
  CustomerSupportNumber,
} from 'components'
import { processErrorMsg } from 'utils'

const ErrorRedirect: FC = (error: any) => {
  processErrorMsg(
    JSON.stringify(error),
    'Implicit Callback',
    'Login flow - Implicit Callback error',
  )

  return (
    <BaseLayout>
      <Module>
        <ModuleHeader title={''}>
          <CustomAlert severity="error">
            We're sorry, your request is unauthorized!
            <br />
            Please try again or call customer support for further assistance at{' '}
            <CustomerSupportNumber />
            <br />
            <br />
            <b>Technical details</b>
            <br />
            Error Name: {error.error.name}
            <br />
            Error Message: {error.error.message}
            <br />
            Error Code: {error.error.errorCode}
            <br />
            Error Summary: {error.error.errorSummary}
            <br />
            Error Link: {error.error.errorLink}
            <br />
            Error Id: {error.error.errorId}
            <br />
            Error Causes (if any): {JSON.stringify(error.error.errorCauses)}
          </CustomAlert>
        </ModuleHeader>
        <ButtonContainer
          secondary={<RouteLink to={routes.login}>Return To Login</RouteLink>}
        />
      </Module>
    </BaseLayout>
  )
}

/**
 * The LoginCallback component in the React SDK contains logic to parse the
 * response Okta sends back to your application.
 */
const ImplicitCallback: FC = () => (
  <LoginCallback errorComponent={ErrorRedirect} />
)

export default ImplicitCallback
